import { AuthSessionStore } from '../api/auth_session.js';
import { AppsFlyer } from '../plugins/apps_flyer_plugin.js';

let bound = false;

export function customerUserIdFromPlayerId( player_id: number | null ): string | null
{
  if ( player_id === null || !Number.isSafeInteger( player_id ) || player_id <= 0 ) return null;
  return String( player_id );
}

function applyPlayerId( player_id: number | null ): void
{
  const uid = customerUserIdFromPlayerId( player_id );
  if ( uid ) void AppsFlyer.setCustomerUserId( uid );
}

export function bindAppsFlyerCustomerUserId(): void
{
  if ( bound ) return;
  bound = true;
  applyPlayerId( AuthSessionStore.getPlayerId() );
  AuthSessionStore.onPlayerId( applyPlayerId );
}
